import React, { useState } from 'react';
import { gql, useLazyQuery } from '@apollo/client';

const GET_ISSUED_PDF = gql`
 query IssuedAvrDownload($id: ID!) {
   issuedAvrPdf(_id: $id) {
     filename mime_type byte_length sha256 content_base64
   }
 }
`;
/** Client may download ONLY the saved, server-verified bytes. */
export default function IssuedAvrDownloadButton({ reportId }) {
    const [localError, setLocalError] = useState('');
    const [fetchPdf, {loading, error}] = useLazyQuery(GET_ISSUED_PDF,{
        fetchPolicy:'no-cache',
        onCompleted: async result => {
            try {
                const file = result?.issuedAvrPdf;
                if (!file || file.mime_type !== 'application/pdf' ||
                    !/^[a-f0-9]{64}$/i.test(file.sha256))
                    throw new Error('Invalid issued PDF response.');
                // Decode in chunks to avoid building one enormous string for
                // hundreds-of-pages AVR reports.
                const encoded=file.content_base64 || '';
                const buffers=[];
                let length=0;
                for(let pos=0;pos<encoded.length;pos+=32768){
                    const chunk=atob(encoded.slice(pos,pos+32768));
                    const bytes=Uint8Array.from(chunk,c=>c.charCodeAt(0));
                    buffers.push(bytes);length+=bytes.length;
                }
                if(length!==file.byte_length)throw new Error('PDF size mismatch.');
                if(!window.crypto?.subtle)throw new Error('Secure PDF digest check unavailable.');
                const combined=new Uint8Array(length);
                let offset=0;for(const chunk of buffers){combined.set(chunk,offset);offset+=chunk.length;}
                const digest=await window.crypto.subtle.digest('SHA-256',combined);
                const verified=[...new Uint8Array(digest)]
                    .map(x=>x.toString(16).padStart(2,'0')).join('');
                if(verified!==file.sha256.toLowerCase())
                    throw new Error('Downloaded PDF failed SHA-256 validation.');
                const blob=new Blob([combined],{type:'application/pdf'});
                const href=URL.createObjectURL(blob);
                const anchor=document.createElement('a');
                anchor.href=href;anchor.download=file.filename||'Issued-AVR.pdf';
                document.body.appendChild(anchor);anchor.click();anchor.remove();
                setTimeout(()=>URL.revokeObjectURL(href),1000);
                setLocalError('');
            }catch(_){setLocalError('Unable to verify the issued PDF. No file was downloaded.');}
        }
    });
    return <span className="inline-block">
        <button type="button" className="button-red" disabled={!reportId || loading}
            aria-busy={loading} onClick={()=>{setLocalError('');fetchPdf({variables:{id:reportId}});}}>
            {loading?'Checking issued PDF...':'Download Issued PDF'}
        </button>
        {(localError || error) && <span className="block text-red-800 mt-2" role="alert">
            {localError || 'Issued PDF cannot be retrieved. Check your access and retry.'}
        </span>}
    </span>;
}
